import React from 'react'
import '../styles/Tag.css'

const Tag = () => {
  return (
    <div className='tag'>
      <h3>Get Mangas, Merch, Mobile Covers and much more....</h3>
    </div>
  )
}

export default Tag